import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { RateOfferVariables, OfferData } from "./types";
import { offersKeys } from "./utils";

export const useRateOffer = (
  options?: UseMutationOptions<void, PortalAxiosError, RateOfferVariables>
) => {
  const server = useServer();
  const queryClient = useQueryClient();

  return useMutation<void, PortalAxiosError, RateOfferVariables>(
    (variables) => {
      const offer = queryClient.getQueryData<OfferData>(
        offersKeys.getOne(variables.identifier)
      );

      return server.post(`offers/${variables.identifier}/rate`, {
        kind: variables.kind ?? offer?.data.kind,
        rating: variables.rating,
      });
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(offersKeys.getOne(variables.identifier));

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};

export default useRateOffer;
